// extracted by mini-css-extract-plugin
export default {"heading":"Gr-z","corrected":"Hr-z","redirectVerbiageContainer":"Ir-z","redirectVerbiageText":"Jr-z"};